// カウントアップの関数（カンマ付き）
export const countUp = (element, start, end, duration) => {
  if(element.getAttribute('data-counted')) return;

  element.setAttribute('data-counted', 'true');

  let startTime = null;
  const step = (timestamp) => {
    if (!startTime) startTime = timestamp;
    const progress = Math.min((timestamp - startTime) / duration, 1);
    const currentNumber = Math.floor(progress * (end - start) + start);
    element.textContent = currentNumber.toLocaleString(); // カンマ付きで表示
    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  };
  window.requestAnimationFrame(step);
}